import Box from '@app/components/common/Box';
import Typography from '@app/components/common/Typography';
import { ITypography } from '@app/components/common/Typography/Typography';
import { AmountRowStyles } from './styles';

interface IAmountRow {
  data: [string | number, string | number, string | number, string | number];
  isHeader?: boolean;
  textProps?: Omit<ITypography, 'children'>;
}

const AmountRow = ({ data, isHeader, textProps }: IAmountRow) => {
  return (
    <Box csx={AmountRowStyles}>
      <Box csx={{ width: '14%' }}>
        <Typography fontWeight={isHeader ? 'bold' : undefined} {...textProps}>
          {data[0]}
        </Typography>
      </Box>
      <Box csx={{ width: '28.66%' }}>
        <Typography
          fontWeight={isHeader ? 'bold' : undefined}
          align="right"
          {...textProps}>
          {data[1]}
        </Typography>
      </Box>
      <Box csx={{ width: '28.66%' }}>
        <Typography
          fontWeight={isHeader ? 'bold' : undefined}
          align="right"
          {...textProps}>
          {data[2]}
        </Typography>
      </Box>
      <Box csx={{ width: '28.66%' }}>
        <Typography
          fontWeight={isHeader ? 'bold' : undefined}
          align="right"
          {...textProps}>
          {data[3]}
        </Typography>
      </Box>
    </Box>
  );
};

export default AmountRow;
